import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

import { translation } from '../../../utils/helpers'
import { formatDate } from '../../../utils/time'
import { getCapacityOverview } from '../../../actions/calendarOverview'
import { closeOverlay, openSlidePanel, closeSlidePanel } from '../../../actions/common'
import { CapacityManagementIcons, GeneralIcons } from '../../elements/icons'
import { getOrderDataNew, setEmployees } from '../../../actions/assign'
import { getEmployees } from '../../../actions/employees'
import { OrderSteps } from '../../../constants'

import Overlay from '../../elements/overlay'
import CalendarHeader from '../../components/Calendar/calendarHeader'
import CalendarFooter from '../../components/Calendar/calendarFooter'
// import CalendarRow from '../../components/Calendar/calendarRow'
import CalendarRowWeek from '../../components/Calendar/calendarRowWeek'
import CalendarRowMonth from '../../components/Calendar/calendarRowMonth'
import CalendarRowGroup from '../../components/Calendar/calendarRowGroup'
import CalendarOrderInfo from '../../components/Calendar/calendarOrderInfo'
import OverviewOrderInfo from '../../overlays/OrderCapacityOverview/overviewOrderInfo'
import OverlayContent from '../../elements/overlayContent'
import IconAccordion from '../../elements/iconAccordion'
import Avatar from '../../elements/avatar'
import CalendarItemStatus from '../../components/Calendar/calendarItemStatus'
import DateTime from '../../elements/datetime'
// import Null from '../../elements/null'

// import ButtonGroup from '../../elements/buttonGroup'
// import ButtonGroupButton from '../../elements/buttonGroupButton'
import Grid from '../../elements/grid'
import OverlayHeaderBare from '../../components/OverlayHeaderBare'
import CalendarItem from '../../components/Calendar/calendarItem'
import CalendarContent from '../../components/Calendar/calendarContent'
import Calendar from '../../components/Calendar/calendar'
import Button from '../../elements/button'
import InfoBar from './infoBar'
import FilterBar from './filterBar'
import Inline from '../../elements/inline'
import Icon from '../../elements/icon'
// import Check from '../../elements/check'

import './orderCapacityOverview.scss'
// import Label from '../../elements/label'
// import ArrowButton from '../../elements/arrowButton'
import CalendarItemStep from '../../components/Calendar/calendarItemStep'
import FilterSlidePanel from './FilterSlidePanel'
import ProgressLine from '../../elements/progressLine'
import TimelineSlidePanel from './TimelineSlidePanel'
import LabelWrapper from '../../elements/labelWrapper'
// import CloseButton from '../../elements/closeButton'
import ScrollToTop from '../../elements/scrollToTop'
import CircleButton from '../../elements/circleButton'
import AssignBox from '../../../pages/NewWorkscreen/AssignBox'
import AssignItem from '../../../pages/NewWorkscreen/AssignItem'

import NewOrdersModal from '../../../shared/modals/NewOrdersModal'

const SparePartStatus = {
  None: 0, // Are ready
  Unknown: 1, // Await order
  NotInUse: 2,
  InStock: 4, // Are ready
  Ordered: 8, // Await receipt
  Received: 16, // Are ready
  Defective: 32,
  Incorrect: 64
}
const CalendarViews = {
  Week: 0,
  Month: 1,
  Day: 2
}
const itemsHeight = {
  padding: 72 // all padding from overlay-content
}
// calendar item step style
const StepClasses = {
  None: '',
  BufferStart: 'capacity-calendar-item-step--buffer',
  BufferEnd: 'capacity-calendar-item-step--buffer',
  BodyStart: 'capacity-calendar-item-step--green',
  BodyEnd: 'capacity-calendar-item-step--green',
  Coating: 'capacity-calendar-item-step--coating',
  EarliestStartGap: 'capacity-calendar-item-step--coating'
}

const StepTypes = [
  'None',
  'BufferStart',
  'BufferEnd',
  'BodyStart',
  'BodyEnd',
  'Coating',
  'BodyStartStatus',
  'BodyEndStatus',
  'CoatingStatus',
  'EarliestStartGap'
]
const StatusTypes = [
  'None',
  'Green',
  'Red',
  'Yellow'
]
const StatusColors = {
  None: 'none',
  Green: 'green',
  Red: 'red',
  Yellow: 'yellow'
}

class OrderCapacityOverview extends Component {
  constructor (props) {
    super(props)
    this.interval = null
    this.viewScroll = 0
    this.today = formatDate(moment().startOf('day'))
    this.state = {
      filter: {
        unassigned: false,
        arrived: false,
        estimationApproved: false,
        sparePartsAreReady: false,
        sparePartsAwaitReception: false,
        sparePartsAreAwaitingOrder: false,
        selectedEmployees: []
      },
      view: CalendarViews.Month,
      grouped: true,
      originalOverview: null,
      filteredOverview: null,
      topNodeHeight: 0,
      orderContentHeight: 0,
      totalCalendarRowsContentHeight: 0,
      showInfoBar: false,
      showFilterBar: false,
      isActiveFilter: false,
      assign_open: false,
      createDraft: {
        open: false,
        pickup: null,
        employee: null,
        steps: []
      },
      StepAssignments: [],
      groupStates: {},
      assignableEmployees: [],
      employeesMap: [],
      activeEmployees: [],

      requestData: {
        WeekType: 0,
        CurrentViewRange: formatDate(moment().startOf('week'))
      },

      filterPanelView: '',
      isFilterSlidePanelOpen: false,
      isTimeLineSlidePanelOpen: false,
      selectedTimelineOrderId: null
    }

    this.updateState = this.updateState.bind(this)
    this.checkHeight = this.checkHeight.bind(this)
    this.renderRow = this.renderRow.bind(this)
    this.openInfoBar = this.openInfoBar.bind(this)
    this.closeInfoBar = this.closeInfoBar.bind(this)
    this.closeFilterBar = this.closeFilterBar.bind(this)
    this.openFilterBar = this.openFilterBar.bind(this)
    this.goTo = this.goTo.bind(this)
    this.filterOverview = this.filterOverview.bind(this)
    this.filterCarArrived = this.filterCarArrived.bind(this)
    // this.filterUnassigned = this.filterUnassigned.bind(this)
    this.filterEstimationApproved = this.filterEstimationApproved.bind(this)
    this.renderFilter = this.renderFilter.bind(this)
    this.getCapacityOverview = this.getCapacityOverview.bind(this)
    this.resetCapacityOverview = this.resetCapacityOverview.bind(this)
    this.goToThisWeek = this.goToThisWeek.bind(this)
    this.openFilterSlidePanel = this.openFilterSlidePanel.bind(this)
    this.filterRows = this.filterRows.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.openTimelineSlidePanel = this.openTimelineSlidePanel.bind(this)
    this.closeTimelineSlidePanel = this.closeTimelineSlidePanel.bind(this)
    this.resetState = this.resetState.bind(this)
    this.onOverlayShow = this.onOverlayShow.bind(this)
    this.onOverlayHide = this.onOverlayHide.bind(this)
    this.getGroupedData = this.getGroupedData.bind(this)
    this.onRangeUpdated = this.onRangeUpdated.bind(this)
    this.onMonthDayClicked = this.onMonthDayClicked.bind(this)
    this.onAssignUsers = this.onAssignUsers.bind(this)
    // this.openAssign = this.openAssign.bind(this)
    this.renderCalendarHeaderButtons = this.renderCalendarHeaderButtons.bind(this)
    this.toggleWeekOrMonth = this.toggleWeekOrMonth.bind(this)
    this.getAssignOrderData = this.getAssignOrderData.bind(this)
    this.triggerClickAssign = this.triggerClickAssign.bind(this)
    this.closeAssignBox = this.closeAssignBox.bind(this)
    this.toggleGrouped = this.toggleGrouped.bind(this)
    this.startUpdateInterval = this.startUpdateInterval.bind(this)
    this.getGroupStates = this.getGroupStates.bind(this)
    this.createDraft = this.createDraft.bind(this)
    this.saveViewState = this.saveViewState.bind(this)
    this.restoreViewState = this.restoreViewState.bind(this)
    this.onDraftCreated = this.onDraftCreated.bind(this)
    this.collapseAllGroupsExcept = this.collapseAllGroupsExcept.bind(this)
    this.triggerAssignEmployee = this.triggerAssignEmployee.bind(this)
  }

  resetState () {
    this.setState({
      filter: {
        unassigned: false,
        arrived: false,
        estimationApproved: false,
        sparePartsAreReady: false,
        sparePartsAwaitReception: false,
        sparePartsAreAwaitingOrder: false,
        selectedEmployees: []
      },
      view: CalendarViews.Month,
      grouped: true,
      originalOverview: null,
      filteredOverview: null,
      topNodeHeight: 0,
      orderContentHeight: 0,
      showInfoBar: false,
      showFilterBar: false,
      isActiveFilter: false,
      groupStates: {},

      requestData: {
        WeekType: 0,
        CurrentViewRange: formatDate(moment().startOf('week'))
      },

      filterPanelView: '',
      isFilterSlidePanelOpen: false,
      isTimeLineSlidePanelOpen: false,
      selectedTimelineOrderId: null
    })
  }

  componentWillUnmount () {
    this.onOverlayHide()
  }

  onOverlayShow () {
    // udate capacity overview every 15sec.
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
    // when assignment is open, CapacityOverview should not update
    if (!this.state.assign_open) {
      this.startUpdateInterval()
    }
    this.resetState()
    // Get employees before we get capacity data to make sure data can be grouped for any employee
    this.props.getEmployees().then(res => {
      let employees = res.data.filter(x => x.Active && x.Confirmed && x.IsAssignableToOrders).map(x => { return { UserId: x.UserId, Name: x.Name, Initials: x.Initials } })
      let employeesMap = {}
      res.data.filter(x => x.Active && x.Confirmed).map(x => {
        employeesMap[x.UserId] = x
      })
      this.setState({ assignableEmployees: employees, employeesMap: employeesMap }, () => {
        console.log('overlay show -> state:', this.state)
        this.getCapacityOverview()
      })
    })
    window.addEventListener('resize', this.handleResize)
    this.props.setEmployees([])
  }

  startUpdateInterval () {
    if (!this.interval) {
      this.interval = setInterval(() => { this.getCapacityOverview() }, 15000)
    }
  }

  onOverlayHide () {
    window.removeEventListener('resize', null)
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
      this.originalOverview = null
      this.filteredOverview = null
    }
  }

  /**
   * Saves the view state, to let the exact same view be restored later.
   */
  saveViewState (orderId, openDetails = false) {
    const { filter, view, grouped, isActiveFilter, assign_open, groupStates, requestData } = this.state
    const scroll = document.getElementsByClassName('element-overlay')[0].scrollTop
    let viewState = { filter, view, grouped, isActiveFilter, assign_open, groupStates, requestData, orderId: orderId, openDetails: openDetails, scroll: scroll }

    // If there is an employee stored for the create draft popup, store their user ID, so it can be expanded when view state is restored.
    if (this.state.createDraft.employee && this.state.createDraft.employee.UserId > 0) {
      viewState.groupStates[this.state.createDraft.employee.UserId] = true
    }
    window.localStorage.setItem('capacity_viewstate', JSON.stringify(viewState))
  }

  /**
   * Restores the view state from a previously saved state, and removes the saved state from local storage.
   */
  restoreViewState () {
    let viewState = window.localStorage.getItem('capacity_viewstate')
    console.log('restoreViewState', viewState)
    if (viewState === null || viewState === undefined) return false
    try {
      viewState = JSON.parse(viewState)
    } catch (error) {
      viewState = null
      return false
    }

    const checkElementInView = (element) => {
      let rect = element.getBoundingClientRect()
      return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth))
    }
    if (viewState) {
      this.setState({
        ...viewState,
        selectedTimelineOrderId: viewState.orderId || null
      }, () => {
        if (viewState.scroll !== undefined) {
          setTimeout(() => {
            // Attempt to scroll to position that was stored.
            document.getElementsByClassName('element-overlay')[0].scrollTo({ top: viewState.scroll, behavior: 'smooth' })
            if (viewState.orderId) {
              // If there is an order Id stored, try to locate the order and scroll to that too.
              console.log('Try to scroll to', viewState.orderId)
              setTimeout(() => {
                let orderElement = document.body.querySelector('div[data-orderid="' + viewState.orderId + '"]')
                if (orderElement && !checkElementInView(orderElement)) {
                  orderElement.scrollIntoView({block: 'center', behavior: 'smooth'})
                }
              }, 500)
            }
          }, 500)
        }
        setTimeout(() => {
          if (viewState.orderId && viewState.openDetails && this.state.filteredOverview) {
            this.openTimelineSlidePanel(viewState.orderId)
          }
        }, 500)
      })
      window.localStorage.removeItem('capacity_viewstate')
      return true
    }
  }

  handleResize () {
    this.updateState({
      orderContentHeight: 0 // reset this before you get the new content height
    }, () => {
      this.checkHeight()
    })
  }

  getCapacityOverview () {
    this.props.getCapacityOverview({ ...this.state.requestData, CalendarView: this.state.view, currentTime: this.state.currentTime }).then(res => {
      this.state.filter = this.restoreFilterFromStorage(this.state.filter)
      this.today = formatDate(moment().startOf('day'))
      this.state.originalOverview = res.data
      if (this.restoreViewState()) {
        // If view settings were restored, refresh data.
        this.getCapacityOverview()
        return
      }
      this.filterOverview(null, {groupStates: this.getGroupStates()})
      if (this.state.assign_open) {
        this.getAssignOrderData()
      }
    })
  }

  setIsActiveFilter () {
    let isActive = false
    let isChecked = Object.values(this.state.filter).find(x => x === true)
    if (isChecked) isActive = true
    if (this.state.filter.selectedEmployees.length > 0) isActive = true
    if (this.state.isActiveFilter === isActive) return
    this.setState({
      isActiveFilter: isActive
    })
  }

  // Filters originalOverview and sets filteredOverview in state
  filterOverview (newFilter, additionalState) {
    // console.log('additionalState', additionalState)
    let overviewCopy = cloneDeep(this.state.originalOverview)
    let filter = this.state.filter
    if (newFilter) {
      this.saveFilterInStorage(newFilter) // from slide in new filter
      filter = newFilter
    }

    overviewCopy = this.filterRows(overviewCopy, filter)
    this.updateState({
      filteredOverview: overviewCopy,
      filter: filter,
      ...additionalState
      // orderContentHeight: 0 // reset this before you get the new content height
    }, () => {
      this.handleResize()
      this.setIsActiveFilter()
    })
  }

  filterRows (overviewCopy, filter) {
    if (overviewCopy === null) return null
    overviewCopy.Rows = overviewCopy.Rows.filter(x =>
      this.filterCarArrived(filter, x) &&
      this.filterEstimationApproved(filter, x) &&
      // this.filterUnassigned(filter, x) &&
      this.filterSparePartsAreReady(filter, x) &&
      this.filterSparePartsAwaitReceipt(filter, x) &&
      this.filterSparePartsAreAwaitingOrder(filter, x) &&
      this.filterEmployee(filter, x)
    )
    return overviewCopy
  }

  saveFilterInStorage (value) {
    window.localStorage.setItem('CapacityOverviewfilter', JSON.stringify(value))
  }

  restoreFilterFromStorage (value) {
    var storedFilter = window.localStorage.getItem('CapacityOverviewfilter')// Get the existing data

    // Handle invalid filter data in local storage
    try {
      storedFilter = storedFilter ? JSON.parse(storedFilter) : value // If no existing data, create new object
    } catch (error) {
      return value
    }

    return storedFilter
  }

  filterCarArrived (filter, row) {
    if (!filter.arrived) {
      return true
    } else if (row.HasCarArrived) {
      return true
    }
    return false
  }

  filterEstimationApproved (filter, row) {
    if (!filter.estimationApproved) {
      return true
    } else if (row.IsEstimationApproved) {
      return true
    }
    return false
  }

  // filterUnassigned (filter, row) {
  //   if (!filter.unassigned) {
  //     return true
  //   } else if (row.HasUnassignedSteps) {
  //     return true
  //   }
  //   return false
  // }

  filterSparePartsAreReady (filter, row) {
    if (!filter.sparePartsAreReady) {
      return true
    } else if (row.SparePartStatusSum === SparePartStatus.InStock || row.SparePartStatusSum === SparePartStatus.Received || row.SparePartStatusSum === SparePartStatus.None) {
      return true
    }
    return false
  }

  filterSparePartsAwaitReceipt (filter, row) {
    if (!filter.sparePartsAwaitReception) {
      return true
    } else if (row.SparePartStatusSum === SparePartStatus.Ordered) {
      return true
    }
    return false
  }

  filterSparePartsAreAwaitingOrder (filter, row) {
    if (!filter.sparePartsAreAwaitingOrder) {
      return true
    } else if (row.SparePartStatusSum === SparePartStatus.Unknown) {
      return true
    }
    return false
  }

  filterEmployee (filter, row) {
    let selectedEmployees = filter.selectedEmployees
    let employeesInRow = []
    let unAssignUser = {UserId: 0}
    if (selectedEmployees.length > 0) {
      row.Assignments.map(assignment => {
        assignment.Employees.map(employee => {
          if (employeesInRow.findIndex(x => x.UserId === employee.UserId) === -1) {
            employeesInRow.push(employee)
          }
        })
      })

      // unassign filter
      if (selectedEmployees.findIndex(x => x === 0) !== -1 && row.HasUnassignedSteps) {
        employeesInRow.push(unAssignUser)
      }

      if (employeesInRow.length > 0) {
        for (let i = 0; i < employeesInRow.length; i++) {
          if (selectedEmployees.findIndex(x => x === employeesInRow[i].UserId) !== -1) {
            return true
          }
        }
      }
      return false
    }
    return true
  }

  /**
   * Opens popup to let user create a draft
   * @param {*} date Pickup date.
   * @param {*} employee Employee to assign when booking from workcard afterwards.
   * @param {*} steps Steps to assign the employee to.
   */
  createDraft (date, employee, steps) {
    // console.log('Create draft', date, employee, steps)
    this.setState({
      createDraft: {
        open: true,
        pickup: date,
        employee: employee,
        steps: steps
      }
    })
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  onDraftCreated (orderId) {
    // console.log('Draft created from capacity', this.state.createDraft, orderId)
    this.saveViewState(orderId)
    this.onOverlayHide()
  }

  getAssignOrderData (activeEmployees) {
    let orderIds = []
    this.state.filteredOverview.Rows.map((val) => {
      orderIds.push(val.Item.OrderId)
    })

    this.props.getOrderDataNew({
      OrderIds: orderIds,
      UserIds: activeEmployees || this.props.activeEmployees
    }).then((res) => {
      this.setState({
        StepAssignments: res.data.StepAssignments
        // activeEmployees: activeEmployees || this.props.activeEmployees
      }, () => {
        // this.handleGroupeStateWhenAssignOpen(true)
      })
    })
    // this.getAssignOrderData(this.props.activeEmployees,orderIds)
  }

  triggerAssignEmployee (activeEmployees) {
    this.setState({
      activeEmployees: activeEmployees || this.props.activeEmployees
    }, () => {
      this.handleGroupeStateWhenAssignOpen(true)
      this.toggleSingleGroupStates(this.state.activeEmployees[0])
      this.getAssignOrderData()
    })
  }

  updateState (newState, cb) {
    this.setState(newState, () => {
      this.checkHeight()
      if (cb) cb()
    })
  }

  checkHeight () {
    // Check top node height
    if (this.refs.overlayContent !== undefined) {
      let padding = itemsHeight.padding
      let calendarHeaderHeight = this.refs.calendarHeaderRef.clientHeight
      let calendarFooterHeight = this.refs.calendarFooterRef.clientHeight
      let calendarFilterContetHeight = this.refs.topNode.clientHeight
      let overlayContent = this.refs.overlayContent.clientHeight
      let calendarGroupFooterHeight = this.refs.calendarGroupFooterRef !== undefined ? this.refs.calendarGroupFooterRef.clientHeight : 0
      let heightResult = padding + calendarHeaderHeight + calendarFooterHeight + calendarFilterContetHeight + calendarGroupFooterHeight
      let orderContentHeight = overlayContent - heightResult

      let rowCount = 0
      let groupHeadingsCount = 0
      if (this.state.filteredOverview && Array.isArray(this.state.filteredOverview.Rows)) {
        if (this.state.grouped) {
          let groupedData = this.getGroupedData()
          groupedData.forEach(g => {
            rowCount += this.state.groupStates[g.Employee.UserId] ? g.Rows.length : 0
            rowCount += 1   // Extra row for the sum line
            groupHeadingsCount++
          })
        } else {
          rowCount = this.state.filteredOverview.Rows.length
        }
      }
      // week row height : 81 ; month row height : 32
      let rowHeight = this.state.view === CalendarViews.Week ? 81 : 32
      let groupHeadingHeight = 40 // this.state.view === CalendarViews.Week ? 40 : 40
      let totalRowsHeight = Math.max(0, (rowCount * rowHeight) + (groupHeadingsCount * groupHeadingHeight) - 1)

      // Update if needed
      if (this.state.orderContentHeight !== orderContentHeight || totalRowsHeight !== this.state.totalCalendarRowsContentHeight) {
        this.setState({
          orderContentHeight: orderContentHeight,
          totalCalendarRowsContentHeight: totalRowsHeight  // (Number of shown orders * 80 height + 1 border) - 1 border for last order
        })
      }
    }
  }

  openFilterSlidePanel (title) {
    this.setState({
      filterPanelView: title,
      selectedTimelineOrderId: null,
      isFilterSlidePanelOpen: true,
      isTimeLineSlidePanelOpen: false
    }, () => {
      this.props.closeSlidePanel('orderTimeline')
      this.props.openSlidePanel('filterOrder')
    })
  }

  closeFilterSlidePanel () {
    this.setState({
      filterPanelView: '',
      isFilterSlidePanelOpen: false
    })
  }

  openTimelineSlidePanel (orderId) {
    this.setState({
      filterPanelView: '',
      selectedTimelineOrderId: orderId,
      isFilterSlidePanelOpen: false,
      isTimeLineSlidePanelOpen: true
    }, () => {
      this.props.closeSlidePanel('filterOrder')
      this.props.openSlidePanel('orderTimeline')
    })
  }

  closeTimelineSlidePanel () {
    this.setState({
      selectedTimelineOrderId: null,
      isTimeLineSlidePanelOpen: false
    })
  }

  openInfoBar () {
    let type = !this.state.showInfoBar
    this.updateState({
      showInfoBar: type,
      orderContentHeight: 0
    })
  }

  triggerClickAssign () {
    this.setState({
      assign_open: !this.state.assign_open
    }, () => {
      // this.toggleGrouped()
      if (this.state.assign_open) {
        this.getAssignOrderData()
        clearInterval(this.interval)
        this.interval = null
        if (!this.state.grouped) {
          this.toggleGrouped()
        }
        this.handleGroupeStateWhenAssignOpen(true)
      } else {
        this.getCapacityOverview()
        this.startUpdateInterval()
      }
    })
    // this.openAssign(type)
  }

  openFilterBar () {
    let type = !this.state.showFilterBar
    this.updateState({
      showFilterBar: type,
      orderContentHeight: 0
    }, () => { this.closeAssignBox() })
  }

  closeFilterBar () {
    this.updateState({
      showFilterBar: false,
      orderContentHeight: 0
    })
  }

  closeInfoBar () {
    this.updateState({
      showInfoBar: false,
      orderContentHeight: 0
    })
  }

  resetCapacityOverview () {
    this.updateState({
      filter: {
        ...this.state.filter,
        unassigned: false,
        arrived: false,
        estimationApproved: false,
        sparePartsAreReady: false,
        sparePartsAwaitReception: false,
        sparePartsAreAwaitingOrder: false,
        selectedEmployees: []
      },
      filterPanelView: ''
    })
  }

  handleGroupeStateWhenAssignOpen (openActiveEmployee) {
    let expandGroups = [0]
    if (this.state.activeEmployees && openActiveEmployee) {
      expandGroups.push(this.state.activeEmployees[0])
      // this.toggleSingleGroupStates(this.state.activeEmployees[0])
    }

    // this.collapseAllGroupsExcept(expandGroups)
    this.collapseAllGroupsExcept([0])
    // this.toggleGroupStates(false) // collapse all
    // this.toggleSingleGroupStates(0) // extended unassinned
    // extende activeEmployee
  }

  toggleGrouped () {
    let groupedStates = {}
    let grouped = !this.state.grouped
    if (grouped) {
      groupedStates = this.getGroupStates()
    }
    this.updateState({
      grouped: grouped,
      groupStates: groupedStates
    })
  }

  toggleWeekOrMonth () {
    let view = this.state.view
    let currentViewRange = this.state.requestData.CurrentViewRange

    switch (this.state.view) {
      case CalendarViews.Month:
        view = CalendarViews.Week
        currentViewRange = formatDate(moment().startOf('week'))
        break
      case CalendarViews.Week:
        view = CalendarViews.Month
        currentViewRange = formatDate(moment().startOf('week'))
        break
    }
    // console.log('Start from ', currentViewRange)
    this.updateState({
      view: view,
      requestData: { ...this.state.requestData, CurrentViewRange: currentViewRange }
    }, () => {
      this.getCapacityOverview()
    })
  }

  /**
   * Fetch new data from API for selected range for month view
   * @param {moment} from
   * @param {moment} to
   */
  onRangeUpdated (from, to) {
    // console.log('onRangeUpdated', from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
    let formattedFromDate = formatDate(from)
    if (this.state.requestData.CurrentViewRange === formattedFromDate) return
    this.setState({
      requestData: {
        ...this.state.requestData,
        CurrentViewRange: formattedFromDate
      }
    }, () => {
      this.getCapacityOverview()
    })
  }

  onMonthDayClicked (date) {
    // console.log('onMonthDayClicked', date)
    // Find start of week, and switch to week view starting with that day.
    let startOfWeek = moment(date).startOf('week')
    this.setState({
      view: CalendarViews.Week,
      requestData: {
        ...this.state.requestData,
        CurrentViewRange: formatDate(startOfWeek)
      }
    }, () => {
      this.getCapacityOverview()
    })
  }

  goToThisWeek () {
    this.setState({
      requestData: {
        CurrentViewRange: formatDate(moment().startOf('week'))
      }
    }, () => {
      this.getCapacityOverview()
    })
  }

  // getHeightStyle () {
  //   const height = this.state.orderContentHeight + 168   // 68 = footer
  //   let heightStyle = {
  //     // height: height > 1 ? height : 'max-content',
  //     // overflowY: 'auto'
  //   }
  //   return heightStyle
  // }
  // getScrollStyle () {
  //   let hideScrollbar = this.state.isFilterSlidePanelOpen || this.state.isTimeLineSlidePanelOpen || this.state.orderContentHeight < 1
  //   return {
  //     overflowY: hideScrollbar ? 'hidden' : ''
  //   }
  // }

  getScrollStyle () {
    let hideScrollbar = this.state.isFilterSlidePanelOpen || this.state.isTimeLineSlidePanelOpen
    return {
      overflowY: hideScrollbar ? 'hidden' : ''
    }
  }

  goTo (path) {
    var newPath = {
      ...this.context.router.location,
      pathname: 'OrderCapacityOverview',
      search: this.context.router.location.pathname
    }
    if (path.includes('orders')) {
      window.LocalstorageStack.push(newPath)
    }

    if (this.state.selectedTimelineOrderId) {
      this.saveViewState(this.state.selectedTimelineOrderId, true)
    }

    this.props.closeOverlay('OrderCapacityOverview')
    this.onOverlayHide()
    let sameLocation = this.context.router.location.pathname === path
    this.context.router.push(path)
    if (sameLocation) {
      window.location.reload()
    }
  }

  allEmployees (row) {
    let allEmployees = []
    row.Assignments.map(assignment => {
      if (assignment.Employees.length > 0) {
        assignment.Employees.map(employee => {
          if (allEmployees.findIndex(x => x.UserId === employee.UserId) === -1) {
            allEmployees.push(employee)
          }
        })
      }
    })
    return allEmployees
  }

  // renderInfo (row) {
  //   let allEmployees = this.allEmployees(row)
  //   if (row.HasUnassignedSteps) {
  //     return [
  //       <span className='calendar-order-info__content__alert' key='0'>{translation('17911')}</span>,
  //       <span key='1' />
  //     ]
  //   }
  //   let firstEmployeeName = ''
  //   if (allEmployees.length > 0) firstEmployeeName = allEmployees[0].Name
  //   if (allEmployees.length > 1) {
  //     return [
  //       <span key='0' className='ellipsis'>{firstEmployeeName}</span>,
  //       <span key='1'>+ {(allEmployees.length - 1)}</span>
  //     ]
  //   }
  //   return [
  //     <span key='0' className='ellipsis'>{firstEmployeeName}</span>
  //   ]
  // }

  renderEmployeeIconAccordion (row) {
    let allEmployees = this.allEmployees(row)
    let customComponents = allEmployees.map(x => { return {customComponent: Avatar, initials: x.Initials, noCircle: true, ariaText: x.Name, ariaPos: 'top-right'} })

    return (
      <IconAccordion icons={customComponents} size='s' />
    )
  }

  renderAlertIconAccordion (row) {
    let alertIcons = []
    if (row.HasDelayedDeliveryToCustomer || row.HasDelayedDeliveryToPaint) alertIcons.push({ icon: CapacityManagementIcons.Warning_delayed, noCircle: true })
    if (row.HasSparePartsNotOrdered) alertIcons.push({ icon: CapacityManagementIcons.Warning_spare_part, noCircle: true })
    if (row.IsOrderStopped) alertIcons.push({ icon: CapacityManagementIcons.Warning_Order_stop, noCircle: true })
    if (row.HasUnassignedSteps) alertIcons.push({ icon: CapacityManagementIcons.Warning_assign, noCircle: true })

    if (alertIcons.length > 0) {
      return (
        <IconAccordion icons={alertIcons} size='s' />
      )
    }
  }

  getConflictAlert (row) {
    let hasConflict = row.HasDelayedDeliveryToPaint || row.HasDelayedDeliveryToPaint || row.HasSparePartsNotOrdered || row.IsOrderStopped || row.HasUnassignedSteps
    return hasConflict
  }

  renderLeftSideIcons (row) {
    let hasConflict = this.getConflictAlert(row)
    let isOrderCompleted = row.Item.CurrentOrderStep === 7 // delivery step
    if (hasConflict) {
      return (
        <div className='leftSideIcons'>
          <Icon icon={CapacityManagementIcons.Warning_attention_white} size='m' />
        </div>
      )
    }
    if (isOrderCompleted) {
      return (
        <div className='leftSideIcons'>
          <Icon icon={CapacityManagementIcons.Completed} size='m' />
        </div>
      )
    }
  }

  onAssignUsers () {
    this.refs.AssignBox.getWrappedInstance().getAssignEmployees()
    this.getCapacityOverview()
  }

  closeAssignBox () {
    this.setState({
      assign_open: false
    }, () => {
      this.getCapacityOverview()
      this.startUpdateInterval()
    })
  }

  getGroupStates () {
    let groupStates = {}

    this.state.assignableEmployees.map(x => {
      groupStates[x.UserId] = true
    })
    groupStates[0] = true
    // Object.keys(this.state.groupStates).forEach((key) => {
    //   // loop state
    //   groupStates[key] = this.state.groupStates[key]
    // })

    groupStates = { ...groupStates, ...this.state.groupStates }
    return groupStates
  }

  /**
   * Move en element in array
   * @param {array} input
   * @param {index} from
   * @param {index} to
   */
  moveElementInArray (input, from, to) {
    let numberOfDeletedElm = 1
    const elm = input.splice(from, numberOfDeletedElm)[0]
    numberOfDeletedElm = 0
    input.splice(to, numberOfDeletedElm, elm)
    return input
  }

  getGroupedData () {
    // Group by employees
    // 1. Gather unique employees from row assignment data.
    let employees = []
    if (this.state.filteredOverview && this.state.filteredOverview.Rows) {
      this.state.filteredOverview.Rows.forEach(row => {
        row.Assignments.forEach(assignment => {
          assignment.Employees.forEach(emp => {
            if (!employees.some(e => e.UserId === emp.UserId) && (this.state.filter.selectedEmployees.length === 0 || this.state.filter.selectedEmployees.some(x => x === emp.UserId))) {
              employees.push(emp)
            }
          })
        })
      })
    }

    // 2. Gather unique employees from all employees that are assignable and merge them.
    if (Array.isArray(this.state.assignableEmployees)) {
      this.state.assignableEmployees.map(emp => {
        if (!employees.some(x => x.UserId === emp.UserId) && (this.state.filter.selectedEmployees.length === 0 || this.state.filter.selectedEmployees.some(x => x === emp.UserId))) {
          employees.push(emp)
        }
      })
    }

    // 3. Sort and add special unassigned employee if filter is empty or it is included in filter. (UserId = 0)
    employees.sort((a, b) => { return a.Name.localeCompare(b.Name) })
    if (!this.state.filteredOverview || !this.state.filteredOverview.Rows) {
      employees.unshift({UserId: 0, Name: translation(17911)}) // add unassign at the first position.
    } else {
      if (this.state.filter.selectedEmployees.length === 0 || this.state.filter.selectedEmployees.some(x => x === 0)) {
        employees.unshift({UserId: 0, Name: translation(17911)}) // add unassign at the first position.
      }
    }

    // 4. Add rows to each group where they belong. (One row can belong to multiple groups)
    let groupedData = []
    employees.forEach(e => {
      let employeeWithRows = { Employee: e, Rows: [] }
      if (this.state.filteredOverview && this.state.filteredOverview.Rows) {
        this.state.filteredOverview.Rows.forEach(r => {
          // add unassign data
          if (r.HasUnassignedSteps && e.UserId === 0) {
            employeeWithRows.Rows.push(r)
          }
          // add assign user data
          if (r.Assignments.some(a => a.Employees.some(ae => ae.UserId === e.UserId))) {
            employeeWithRows.Rows.push(r)
          }
        })
      }

      groupedData.push(employeeWithRows)
    })

    return groupedData
  }

  /**
   * Collapse all groups while expanding for each user in the userIds array
   * @param {Array} userIds Provide user ids for which groups should be expanded
   */
  collapseAllGroupsExcept (userIds) {
    let groupStates = this.state.groupStates
    Object.keys(groupStates).forEach((key) => {
      groupStates[key] = userIds.some(x => String(x) === key)
    })
    this.updateState({
      groupStates: groupStates
    })
  }

  toggleSingleGroupStates (employeeId) {
    if (employeeId === undefined) return
    this.updateState({ groupStates: {...this.state.groupStates, [employeeId]: !this.state.groupStates[employeeId]} })
  }

  toggleGroupStates (expanded) {
    let groupStates = this.state.groupStates
    Object.keys(groupStates).forEach((key) => {
      groupStates[key] = expanded
    })
    this.updateState({
      groupStates: groupStates
    })
  }

  renderRow (row, key) {
    const stepsTypes = [1, 2, 3, 4, 5, 9]
    const statusTypes = [6, 7, 8]

    const getStepTypeClassName = (type) => {
      return StepClasses[StepTypes[type]]
    }

    const getUnAssingedStepClass = (step) => {
      return step.NeedAssignment ? 'capacity-calendar-item-step--isUnAssignStep' : ''
    }

    const getStatusColor = (status) => {
      return StatusColors[StatusTypes[status]]
    }

    let orderInfo =
      <CalendarOrderInfo info={row} onHeaderClick={this.openTimelineSlidePanel.bind(this, row.Item.OrderId)} active={row.Item.OrderId === this.state.selectedTimelineOrderId}>
        {this.renderLeftSideIcons(row)}
        <Grid className='calendar-order-info__content__info' cols={['min-content', 1, 'max-content']} align='center' >
          {this.renderAlertIconAccordion(row)}
          {this.renderEmployeeIconAccordion(row)}
        </Grid>
      </CalendarOrderInfo>

    let renderMonthlyOrderInfo =
      <OverviewOrderInfo info={row} onHeaderClick={this.openTimelineSlidePanel.bind(this, row.Item.OrderId)} orderInfoIcon={this.renderLeftSideIcons(row)} active={row.Item.OrderId === this.state.selectedTimelineOrderId}>
        <div className='alarm-iccordion'>
          {this.renderAlertIconAccordion(row)}
        </div>
        {this.allEmployees(row).length > 0 && <div className='assign-iccordion'>
          {this.renderEmployeeIconAccordion(row)}
        </div>}
      </OverviewOrderInfo>

    const renderCoatingNotBookedIcon = (type) => {
      if (StepTypes[type] === 'Coating' && row.HasPaintNotBooked) {
        return (
          <Icon icon={CapacityManagementIcons.warning_painter} size='s' />
        )
      }
    }

    const renderCalendarItemStatus = (step, statusKey) => {
      return (
       step.Status !== 0 &&
       <CalendarItemStatus key={statusKey} step={step}>
         <ProgressLine color={getStatusColor(step.Status)} style={{width: '100%'}} />
       </CalendarItemStatus>
      )
    }

    const renderAssignItem = (val, key) => {
      if (val.OrderId !== row.Item.OrderId) return
      return (
        <AssignItem router={this.props.router} key={key} item={val} step={row.Item.CurrentOrderStep} index={key} onAssignUsers={this.onAssignUsers} getAssignOrderData={this.getAssignOrderData} assignAriaPos={'bottom-left'} />
      )
    }

    // calender item step content text
    const itemStepContent = (step) => {
      if (this.state.view === CalendarViews.Month) {
        return (
          <div className='capacity-calendar-item-step__icon'>
            {renderCoatingNotBookedIcon(step.Type)}
          </div>
        )
      } else {
        return (
          <div>
            <div className='capacity-calendar-item-step__title'>
              <Inline spacing={0}>
                {step.TextPrimary}
                {renderCoatingNotBookedIcon(step.Type)}
              </Inline>
            </div>
            <div className='capacity-calendar-item-step__subtitle'>{step.TextSecondary}</div>
          </div>
        )
      }
    }

    const renderCalenderItemSteps = (step, k) => {
      return (
        <CalendarItemStep key={k} step={step} >
          <div className={getStepTypeClassName(step.Type) + ' ' + getUnAssingedStepClass(step)}>
            {itemStepContent(step)}
          </div>
        </CalendarItemStep>
      )
    }

    // Show week row
    let thisStepAssignments = this.state.StepAssignments.filter(x => x.StepId === row.Item.CurrentOrderStep)
    let orderAssignments
    if (thisStepAssignments.length > 0) orderAssignments = thisStepAssignments[0].OrderAssignments
    // console.log('orderAssignments', orderAssignments)
    const renderCalenderRowWeek = () => {
      // this.getAssignOrderData(this.props.activeEmployees, row.Item.OrderId)
      return (
        <CalendarRowWeek rowColumns={this.state.originalOverview.Days} info={row} orderInfo={orderInfo} key={key}>
          <CalendarItem item={row.Item}>
            {row.Item.Steps.map((step, stepKey) => {
              if (stepsTypes.includes(step.Type)) {
                return (
                  renderCalenderItemSteps(step, stepKey)
                )
              } else if (statusTypes.includes(step.Type)) {
                return (
                  renderCalendarItemStatus(step, stepKey)
                )
              }
            })}
          </CalendarItem>
          {this.state.assign_open && orderAssignments && orderAssignments.length > 0 && (
            orderAssignments.map(renderAssignItem)
          )}
        </CalendarRowWeek>
      )
    }

    // Show month row
    const renderCalenderRowMonth = () => {
      return (
        <CalendarRowMonth rowColumns={this.state.originalOverview.Days} info={row} orderInfo={renderMonthlyOrderInfo} key={key}>
          <CalendarItem item={row.Item}>
            {row.Item.Steps.map((step, stepKey) => {
              if (stepsTypes.includes(step.Type)) {
                return (
                  renderCalenderItemSteps(step, stepKey)
                )
              } else if (statusTypes.includes(step.Type)) {
                return (
                  renderCalendarItemStatus(step, stepKey)
                )
              }
            })}
          </CalendarItem>
          {this.state.assign_open && orderAssignments && orderAssignments.length > 0 && (
            orderAssignments.map(renderAssignItem)
          )}
        </CalendarRowMonth>
      )
    }

    return (
      <div key={'row_' + key} data-orderId={row.Item.OrderId}>
        {this.state.view === CalendarViews.Week && renderCalenderRowWeek()}
        {this.state.view === CalendarViews.Month && renderCalenderRowMonth()}
      </div>
    )
  }

  renderOrderCount () {
    if (this.state.originalOverview === null || this.state.filteredOverview == null) return
    let numberOfactiveOrders = this.state.originalOverview.Rows.length
    let numberOfFilteredOrders = this.state.filteredOverview.Rows.length
    let text = translation('17910')
    text = text.replace('[filtered]', numberOfFilteredOrders).replace('[total]', numberOfactiveOrders)
    return (
      <span className='black-h-1-left orders-showing'>{text}</span>
    )
  }

  renderFilter () {
    const onchange = (e) => {
      // console.log('e.target.name', e.target.name)
      if (e !== undefined) {
        let filter = this.state.filter
        if (e.target.name === 'unassigned') {
          filter.unassigned = !this.state.filter.unassigned
        }
        if (e.target.name === 'arrived') {
          filter.arrived = !this.state.filter.arrived
        }
        if (e.target.name === 'estimationApproved') {
          filter.estimationApproved = !this.state.filter.estimationApproved
        }
        this.saveFilterInStorage(filter)
        this.setState({
          filter: filter
        })
      }
      this.filterOverview()
    }

    return (
      <div className='filter-bar'>
        <FilterBar onClose={this.closeFilterBar} onChange={onchange} filter={this.state.filter} openFilterSlidePanel={this.openFilterSlidePanel.bind(this)} />
      </div>
    )
  }

  renderTopNavigation () {
    return (
      <Grid cols={['max-content', 'max-content', 'max-content']} align='center'>
        <Button style='link' size='m' spacing={0} onClick={() => this.goTo('/CarRentals/Overview')} labelText={(
          <Inline spacing={0}>
            <Icon icon={CapacityManagementIcons.CarRental_Black} size='s' injectSvg />
            {translation('17902')}
          </Inline>
        )} />
        <Button style='link' size='m' spacing={0} onClick={() => this.goTo('/orders')} labelText={(
          <Inline spacing={0}>
            <Icon icon={CapacityManagementIcons.OrderList_Black} size='s' injectSvg />
            {translation('14876')}
          </Inline>
        )} />
        <Button style='link' size='m' spacing={0} onClick={() => this.goTo('/workscreen')} labelText={(
          <Inline spacing={0}>
            <Icon icon={CapacityManagementIcons.Chain_Black} size='s' injectSvg />
            {translation('18')}
          </Inline>
        )} />
      </Grid>
    )
  }

  getFooterStyle () {
    let footerheight = {
      height: this.state.view === CalendarViews.Month ? 32 : 68
    }
    return footerheight
  }

  renderFooterItems (group) {
    const {filteredOverview, originalOverview, grouped, filter} = this.state
    let filteredOrderIds = filteredOverview.Rows.map(x => x.Item.OrderId)
    const groupDaysByWeek = originalOverview.Days.reduce((group, value) => {
      if (!group[value.Week]) {
        group[value.Week] = []
      }
      group[value.Week].push(value)
      return group
    }, {})

    // use to get the total minutes <retunr true otherwise false>
    const getTotalMinutes = (item) => {
      let totalMinutes = 0
      for (let i = 0; i < item.Orders.length; i++) {
        let orderId = item.Orders[i].OrderId
        if (filteredOrderIds.findIndex(x => x === orderId) !== -1) {
          item.Orders[i].Assignments.forEach(x => {
            // Add minutes if employee filter is empty or employee of assignment is included in filter
            if (grouped && (group && group.Employee.UserId === x.UserId) || (!grouped && (!filter.selectedEmployees || filter.selectedEmployees.length === 0 || filter.selectedEmployees.some(e => e === x.UserId)))) {
              totalMinutes += x.AssignedMinutesWithGain
            }
          })
        }
      }
      // if (totalMinutes > 0) console.log('item.Date', item.Date, ' Minutes => ', totalMinutes, ' => ', (totalMinutes / 60))
      return totalMinutes
    }
    // use to get the sum of the total minutes per week <retunr true otherwise false>
    const getSumOfTotalMinutes = (week) => {
      let sum = 0
      groupDaysByWeek[week].map((item) => {
        sum += getTotalMinutes(item)
      })
      // console.log('sum of week ', week, ' => ', groupDaysByWeek[week], ' => ', sum)
      return sum
    }
    const SATURDAY = 6
    const SUNDAY = 0

    // use to check when we need to show total hours <retunr true otherwise false>
    const canShowTotalHours = (item) => {
      let canShow = false
      // console.log('canShowTotalHours', item)
      // let dayOfWeek = moment(item.Date).isoWeekday()   // Apparently moment is quite slow when being used frequently, moved logic to API.
      let dayOfWeek = item.DayOfWeek
      let isSaturdayAndSundayClosed = IsSaturdayAndSundayClosed(item.Week)
      if ((dayOfWeek === SATURDAY || dayOfWeek === SUNDAY) && isSaturdayAndSundayClosed) {
        canShow = true
        // this is only used for week
      } else if (this.state.view === CalendarViews.Week && !isSaturdayAndSundayClosed && dayOfWeek === SUNDAY && item.IsClosed) {
        canShow = true
      }
      return canShow
    }

    // use to check if saturday and sunday is closed <retunr true otherwise false
    const IsSaturdayAndSundayClosed = (week) => {
      let isBothWeekDaysClosed = false
      let isSaturdayClosed = false
      let isSundayClosed = false

      groupDaysByWeek[week].map((item) => {
        let dayOfWeek = item.DayOfWeek
        if (dayOfWeek === SATURDAY && item.IsClosed) isSaturdayClosed = true
        if (dayOfWeek === SUNDAY && item.IsClosed) isSundayClosed = true
      })

      isBothWeekDaysClosed = isSaturdayClosed && isSundayClosed
      return isBothWeekDaysClosed
    }

    return originalOverview.Days.map((item, key) => {
      let totalMinutes = getTotalMinutes(item)
      let hours = Math.trunc(totalMinutes / 60)
      let classNames = 'calendar-footer__column'
      if (group && group.Employee.UserId === 0) classNames += ' unassigned'
      let time = ''

      let canShowTotalHoursForDay = canShowTotalHours(item)

      // Week items
      if (this.state.view === CalendarViews.Week) {
        // Format minutes to hours/minutes
        let sumMinutes = getSumOfTotalMinutes(item.Week)
        let sumTotalHours = Math.trunc(sumMinutes / 60)
        let sumTotalMinutes = Math.round(sumMinutes) % 60
        let minutes = Math.round(totalMinutes) % 60
        let hourText = !canShowTotalHoursForDay ? hours : 'Σ' + sumTotalHours
        let hourMinut = !canShowTotalHoursForDay ? minutes : sumTotalMinutes
        time = hourText + ':' + ('' + hourMinut).padStart(2, '0') + ' ' + translation('17922')
        classNames += ' weekly'
      }

      // Month items
      if (this.state.view === CalendarViews.Month) {
        // console.log(item.Date)
        time = Math.round(totalMinutes / 60)
        if (canShowTotalHoursForDay) {
          let totalHours = Math.round(getSumOfTotalMinutes(item.Week) / 60)
          time = 'Σ' + totalHours + '' + translation('17922')
        }

        // hours = Math.round(totalMinutes / 60)
        // time = !canShowTotalHoursForDay ? hours : 'Σ' + totalHours + '' + translation('17922')
        classNames += ' monthly'
      }

      if (item.IsClosed) {
        let isBothWeekDaysClosed = IsSaturdayAndSundayClosed(item.Week)
        classNames += ' closed'
        let dayOfWeek = item.DayOfWeek
        if (dayOfWeek === SATURDAY && isBothWeekDaysClosed) classNames += ' saturday-longweek'
        if (dayOfWeek === SUNDAY && isBothWeekDaysClosed) {
          classNames += ' sunday-longweek'
          time = ''
        }
      }
      let isEmployeeAssignable = !group || group.Employee.UserId === 0 || this.state.employeesMap[group.Employee.UserId] && this.state.employeesMap[group.Employee.UserId].IsAssignableToOrders

      // console.log('render footer: ', this.state)
      let isBeforeToday = item.Date < this.today
      time = item.IsClosed && !canShowTotalHoursForDay ? '' : time
      const defaultAssignToSteps = [OrderSteps.NEW_ORDER, OrderSteps.DISASSEMBLY, OrderSteps.REPAIR, OrderSteps.ASSEMBLY, OrderSteps.BODY_FINISHING, OrderSteps.DELIVERY]
      return (
        <div className={classNames} key={key}>
          <div className='calendar-footer__minute'>
            {time}
            {!item.IsClosed && !isBeforeToday && this.state.grouped && isEmployeeAssignable && <div className='create-draft-btn' onClick={this.createDraft.bind(this, item.Date, group.Employee, defaultAssignToSteps)}>+</div>}
            {!item.IsClosed && !isBeforeToday && !this.state.grouped && isEmployeeAssignable && <div className='create-draft-btn' onClick={this.createDraft.bind(this, item.Date, { UserId: 0 }, defaultAssignToSteps)}>+</div>}
          </div>
        </div>
      )
    })
  }

  renderHeaderIcons () {
    let style = this.state.isActiveFilter ? 'active' : 'link'
    return (
      <div className='headerIcons'>
        <Grid cols={['max-content', 'max-content', 'max-content']} align='center'>
          <CircleButton onClick={() => this.triggerClickAssign()} icon={CapacityManagementIcons.Assign} /> {/* assign icon */}
          <CircleButton style={style} onClick={() => this.openFilterBar()} icon={CapacityManagementIcons.Filter} /> {/* loop icon */}
          <CircleButton onClick={() => this.openInfoBar()} icon={CapacityManagementIcons.info} /> {/* Info icon */}
        </Grid>
      </div>
    )
  }

  renderCalendarHeaderButtons () {
    return (
      <div className='buttons'>
        <CircleButton size='m' icon={CapacityManagementIcons.List_View} onClick={this.toggleGrouped} />
        <CircleButton size='m' icon={CapacityManagementIcons.Calendar} onClick={this.toggleWeekOrMonth} />
      </div>
    )
  }

  renderContentList () {
    let hasData = this.state.originalOverview !== null && this.state.originalOverview.Rows !== undefined && this.state.filteredOverview !== null && this.state.filteredOverview.Rows !== undefined
    return (
      <CalendarContent style={{height: this.state.totalCalendarRowsContentHeight}} ignoreHeight={this.state.topNodeHeight}>
        {/* <div ref='calendarRowRef' className='calendar-container' style={this.getScrollStyle()}></div> */}
        <div ref='calendarRowRef' className='calendar-container'>
          {hasData && this.state.filteredOverview.Rows.map(this.renderRow)}
        </div>
      </CalendarContent>
    )
  }

  renderContentGrouped () {
    let hasData = this.state.originalOverview !== null && this.state.originalOverview.Rows !== undefined && this.state.filteredOverview !== null && this.state.filteredOverview.Rows !== undefined
    let groupedData = this.getGroupedData()
    if (groupedData === null || groupedData.length === 0) return
    let allGroupsExpanded = Object.keys(this.state.groupStates).every(x => this.state.groupStates[x])

    let newGroupeData = groupedData
    if (this.state.activeEmployees && this.state.assign_open) {
      let elmIndex = groupedData.findIndex(x => x.Employee.UserId === this.state.activeEmployees[0])
      // console.log('renderContentGrouped, groupedData', groupedData)
      let destinationIndex = groupedData[0].Employee.UserId === 0 ? 1 : 0 // If first empl. is 'unassigned', move active employee below (to index 1), otherwise, move to top (index 0).
      if (elmIndex > -1) {
        newGroupeData = this.moveElementInArray(groupedData, elmIndex, destinationIndex)
      }
    }

    const renderControls = (employee) => {
      let groupExpanded = this.state.groupStates[employee.UserId]
      // let footerClasses = 'calendar-row-group-footer-container' + (!groupFoldState || !thisEmployeeState ? ' headindFooter' : '')
      return (
        <div className='fold-controls'>
          {allGroupsExpanded && <Icon icon={CapacityManagementIcons.Group_Arrow_Down} size='t' onClick={this.toggleGroupStates.bind(this, false)} injectSvg />}
          {!allGroupsExpanded && <Icon icon={CapacityManagementIcons.Group_Arrow_Right} size='t' onClick={this.toggleGroupStates.bind(this, true)} injectSvg />}

          {groupExpanded && <Icon icon={CapacityManagementIcons.Arrow_Down} size='t' onClick={this.toggleSingleGroupStates.bind(this, employee.UserId)} injectSvg />}
          {!groupExpanded && <Icon icon={CapacityManagementIcons.Arrow_Right} size='t' onClick={this.toggleSingleGroupStates.bind(this, employee.UserId)} injectSvg />}
        </div>
      )
    }

    const renderEmployeeInfo = (employee) => {
      let icon = <Avatar size='s' initials={employee.Initials} />
      if (employee.UserId === 0) {
        icon = <Icon icon={CapacityManagementIcons.Warning_assign} size='s' injectSvg />
      }

      return (
        <div className='employee-group-heading'>
          {icon}
          <span>{employee.Name}</span>
        </div>
      )
    }

    const getGroupBoxClasses = () => {
      // use to adjust the last box height
      return this.state.assign_open ? 'group-box' : ''
    }

    // const getCustomFooterStyle = (groupFoldState, thisEmployeeState) => {
    //   if (this.state.view === CalendarViews.Week) {
    //     footerClasses += !groupFoldState || !thisEmployeeState ? ' headindFooter-week' : ''
    //   }
    //   if (this.state.view === CalendarViews.Month) {
    //     footerClasses += !groupFoldState || !thisEmployeeState ? ' headindFooter-month' : ''
    //   }
    //   return footerClasses
    // }
    return (
      <CalendarContent style={{height: this.state.totalCalendarRowsContentHeight}} ignoreHeight={this.state.topNodeHeight}>
        {/* <div ref='calendarRowRef' className='calendar-container' style={this.getScrollStyle()}></div> */}
        <div ref='calendarRowRef' className='calendar-container'>
          {hasData && newGroupeData.map(group => {
            let thisEmployeeState = this.state.groupStates[group.Employee.UserId]
            return (
              <div key={'group_' + group.Employee.UserId} className={getGroupBoxClasses()}>
                <CalendarRowGroup renderInfo={renderEmployeeInfo.bind(this, group.Employee)} renderControls={renderControls.bind(this, group.Employee)} open={thisEmployeeState} >
                  {group.Rows.map(this.renderRow)}
                </CalendarRowGroup>
                <div className='calendar-row-group-footer-container' ref='calendarGroupFooterRef'>
                  <CalendarFooter height={this.getFooterStyle()} footerItems={this.state.originalOverview.Days}>
                    {this.renderFooterItems(group)}
                  </CalendarFooter>
                </div>
              </div>
            )
          })}
        </div>
      </CalendarContent>
    )
  }

  render () {
    const originalOverview = this.state.originalOverview
    let hasData = this.state.originalOverview !== null && this.state.originalOverview.Rows !== undefined && this.state.filteredOverview !== null && this.state.filteredOverview.Rows !== undefined
    const hiddecrollStyle = () => {
      if (this.state.isFilterSlidePanelOpen || this.state.isTimeLineSlidePanelOpen) {
        return ' overlay-overflow'
      }
      return ''
    }
    const footerBoxClass = () => {
      return this.state.assign_open && this.state.view === CalendarViews.Month ? 'month-footer-box' : ''
    }
    const closeCreateDraftPopup = () => {
      this.setState({createDraft: { ...this.state.createDraft, open: false }})
      this.startUpdateInterval()
    }

    return (
      <Overlay overlayId='OrderCapacityOverview' extraClassName={'orderCapacityOverview' + hiddecrollStyle()} onShow={this.onOverlayShow} onHide={this.onOverlayHide}>
        <OverlayHeaderBare
          overlayId='OrderCapacityOverview'
          closeButton
          onClose={this.resetCapacityOverview}
        >
          <Grid cols={[ 'min-content', 'max-content', 'max-content', '2fr' ]} align='center'>
            <Icon icon={GeneralIcons.Apromas_Logo} size='l' />
            <span className='black-h-1-left'>{translation('17912')}</span>
            {this.renderTopNavigation()}
            {this.renderHeaderIcons()}
            {false && <LabelWrapper labelText='Fjern mig!'>
              <DateTime
                closeOnSelect
                timeFormat='HH:mm'
                value={''}
                name='Date'
                onBlur={t => this.setState({ currentTime: t._d })}
              />
            </LabelWrapper> /* FOR DEBUG! */}
          </Grid>
        </OverlayHeaderBare>

        <OverlayContent noScroll>
          <div className='content' ref='overlayContent'>
            <div className='content__calendar-filter' ref='topNode'>
              {/* info bar */}
              {this.state.showInfoBar && <InfoBar onClose={this.closeInfoBar} />}
              {/* filter bar */}
              {this.state.showFilterBar && this.renderFilter()}
            </div>

            <Calendar>
              <div className='calendar-header-container' ref='calendarHeaderRef'>
                {hasData && <CalendarHeader headerItems={originalOverview.Days} viewMode={this.state.view === CalendarViews.Month ? 'month' : 'week'} onRangeUpdated={this.onRangeUpdated} onItemClick={this.onMonthDayClicked} showFromDate={moment(this.state.requestData.CurrentViewRange)} renderButtons={this.renderCalendarHeaderButtons} />}
              </div>
              {this.state.grouped && this.renderContentGrouped() || this.renderContentList()}
              <div className='calendar-footer-container' ref='calendarFooterRef'>
                {hasData && !this.state.grouped &&
                  <div className={footerBoxClass()}>
                    <CalendarFooter height={this.getFooterStyle()} footerItems={originalOverview.Days}>
                      {this.renderFooterItems(null)}
                    </CalendarFooter>
                  </div>}
                {hasData && this.state.assign_open && (
                  <div className={this.state.view === CalendarViews.Month ? 'AssignBox-month' : 'AssignBox-week'} >
                    <AssignBox router={this.props.router} ref='AssignBox' closeAssign={() => { this.closeAssignBox() }} onEmployeeChange={this.triggerAssignEmployee} assignAriaPos={'left'} hideHeader />
                  </div>
                )}
              </div>
            </Calendar>
          </div>

          <FilterSlidePanel
            data={this.state.originalOverview}
            view={this.state.filterPanelView}
            filterStatus={this.state.filter}
            onClose={this.closeFilterSlidePanel.bind(this)}
            filterOverview={this.filterOverview}
            filterCollection={this.filterRows}
          />
          <TimelineSlidePanel
            orderId={this.state.selectedTimelineOrderId}
            onClose={this.closeTimelineSlidePanel}
            filterOverview={this.filterOverview}
            currentTime={this.state.currentTime} // FOR DEBUG!
            openWorkcard={this.goTo}
          />
        </OverlayContent>
        <ScrollToTop elementToScrollToClassName={'element-overlay'} />
        <NewOrdersModal router={this.context.router}
          show={this.state.createDraft.open}
          options={{...this.state.createDraft, bookingDestination: 'capacityoverview'}}
          onClose={closeCreateDraftPopup}
          onDraftCreated={this.onDraftCreated}
          bodyShop />

      </Overlay>
    )
  }
}

OrderCapacityOverview.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    activeEmployees: state.assign.activeEmployees
  }
}
export default connect(mapStateToProps, {
  getCapacityOverview,
  closeOverlay,
  openSlidePanel,
  closeSlidePanel,
  getOrderDataNew,
  setEmployees,
  getEmployees
})(OrderCapacityOverview)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/OrderCapacityOverview/index.js